import React from 'react';
import PropTypes from 'prop-types';

import JsonLd from '@/components/common/JsonLd';
import ESpotsLoader from '@/components/layout/espots/ESpotsLoader';
import ProductCardWB from '@/components/winebox/ProductCardWB';
import buildLinkedData from '@/linkedData/products-lkd';
import buildLinkedDataTs from '@/linkedData/trustedShop-lkd';

import styles from './ProductListingWB.module.scss';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { ESPOTS } from '@/constants/espot';

const noProductSpot = [ESPOTS.FILTERS_NOPRODUCTS];
const headerCPEspot = [ESPOTS.HEADER_CP];

export const ProductListingWB = ({
  productList = [], customClassName, url, storeConf, ratingValue, ratingCount
}) => {
  const isMobile = useScreenSizeContext().isMobile;
  const jsonData = buildLinkedData(url, productList, isMobile);
  const jsonTs = buildLinkedDataTs(storeConf, ratingValue, ratingCount);

  return (
    <>
      <JsonLd data={jsonData} />
      <JsonLd data={jsonTs} />

      <div data-rbf="product-listing-cp" className={customClassName}>
        <ESpotsLoader storeId={storeConf.storeId} locations={headerCPEspot} />
        {productList.length > 0 ? (
          <div className={styles.container} data-test-id="product-cp-container">
            {productList.map((product, i) => (
              <div key={i} data-test-id="product-listing-cp-bloc">
                <ProductCardWB product={product} />
              </div>
            ))}
          </div>
        ) : (
          <div className="col-xl-4 col-md-6 col-sm-8 py-3">
            <ESpotsLoader storeId={storeConf.storeId} locations={noProductSpot} />
          </div>
        )}
      </div>
    </>
  );
};

ProductListingWB.propTypes = {
  productList: PropTypes.array,
  customClassName: PropTypes.string,
  url: PropTypes.string,
  storeConf: PropTypes.object,
  ratingValue: PropTypes.number,
  ratingCount: PropTypes.number
};

export default ProductListingWB;
